import { styled } from '@mui/material/styles';
import { Box, TableCell, TableRow, TableContainer, Paper, Typography } from '@mui/material';

export const NotificationsContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(3),
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'calc(100vh - 150px)',
    overflowY: 'auto',
    paddingRight: theme.spacing(1),
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
        width: '10px',
    },
    '&::-webkit-scrollbar-track': {
        backgroundColor: '#1e1e1e',
        borderRadius: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#666',
        borderRadius: '5px',
        '&:hover': {
            backgroundColor: '#888',
        },
    },
}));

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
    flexGrow: 1,
    // maxHeight: '200px',
    maxHeight: 'calc(100vh - 200px)',
    paddingBottom: '22px',
    overflowY: 'auto',
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
        width: '8px',
    },
    '&::-webkit-scrollbar-track': {
        backgroundColor: '#2a2a2a',
        borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#555',
        borderRadius: '4px',
        '&:hover': {
            backgroundColor: '#777',
        },
    },
}));

export const HeaderCell = styled(TableCell)(({ theme }) => ({
    fontWeight: 600,
    backgroundColor: 'black',
    color: 'white',
}));

export const HeaderCellCentered = styled(HeaderCell)(({ theme }) => ({
    textAlign: 'center',
}));

export const DescriptionCell = styled(TableCell)(({ theme }) => ({
    minWidth: 300,
    verticalAlign: 'middle',
}));

export const TripCodeCell = styled(TableCell)(({ theme }) => ({
    verticalAlign: 'middle',
    width: '100px',
}));

export const ActionsCell = styled(TableCell)(({ theme }) => ({
    verticalAlign: 'middle',
    width: '200px',
}));

export const EmptyCell = styled(TableCell)(({ theme }) => ({
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
}));

export const NotificationRow = styled(TableRow)(({ theme }) => ({
    '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    '& td': {
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
        verticalAlign: 'middle',
        borderBottom: '1px solid #444',
    }
}));

export const ActionsContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(1),
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
}));

export const CategoryContainer = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(1),
}));

export const CategoryTitle = styled(Typography)(({ theme }) => ({
    padding: theme.spacing(1),
    color:'#64B5F6',
    fontWeight: 600,
    textTransform: 'capitalize',
    backgroundColor: '#2a2a2a',
    borderBottom: '1px solid #444',
}));

export const CategoryPaper = styled(Paper)(({ theme }) => ({
    borderRadius: theme.spacing(0.5),
    boxShadow: theme.shadows[3],
    backgroundColor: '#2a2a2a',
    overflow: 'hidden',
}));

export const EmptyStateContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(4),
    textAlign: 'center',
}));